import { authenticatedFetch } from '../../../api/request';

export default async function getAllExperiences(doctorUserId, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener las entradas de experiencia.');
    return await authenticatedFetch(`/doctor-profile-management/all-experiences/${doctorUserId}`, onError);
}
